import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { AdjustmentReasonCollectionQuery, AdjustmentReasonCollectionQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(AdjustmentReasonCollectionQuery)
@Wrapper(AdjustmentReasonCollectionQueryHandlerBase)
export class AdjustmentReasonQueryHandler {
    public constructor(
        http: Http
    ) { }
}
